import _ from "lodash";
import i18n from "i18next";

import { formatDimension } from "../../../helpers/unitOfMeasurementHelpers";

const filterCustomerPO = (products, selectedCustomerPO) => {
  return selectedCustomerPO ? products.filter(product => product.customerPO === selectedCustomerPO) : products;
};

const filterDimension = (products, selectedDimension) => {
  return selectedDimension ? products.filter(product => formatDimension(product.dimension) === selectedDimension) : products;
};

const filterProductName = (products, selectedProductName) => {
  return selectedProductName ? products.filter(product => product.productName === selectedProductName) : products;
};

export const filterProducts = (products, selectedCustomerPO, selectedDimension, selectedProductName) => {
  let filteredProducts = products;
  if (selectedCustomerPO) {
    filteredProducts = filteredProducts.filter(product => product.customerPO === selectedCustomerPO);
  }

  if (selectedProductName) {
    filteredProducts = filteredProducts.filter(product => product.productName === selectedProductName);
  }

  if (selectedDimension) {
    filteredProducts = filteredProducts.filter(product => formatDimension(product.dimension) === selectedDimension);
  }

  return filteredProducts;
};

export const getCustomerPOs = (products, selectedProductName, selectedDimension) => {
  let filteredProducts = filterDimension(products, selectedDimension);
  filteredProducts = filterProductName(filteredProducts, selectedProductName);
  filteredProducts = _.uniqBy(filteredProducts, product => product.customerPO);
  const options = filteredProducts.map(product => ({ value: product.customerPO, label: product.customerPO }));

  return [{ value: "", label: i18n.t("billsOfLading.all") }, ...options];
};

export const getProductNames = (products, selectedCustomerPO, selectedDimension) => {
  let filteredProducts = filterCustomerPO(products, selectedCustomerPO);
  filteredProducts = filterDimension(filteredProducts, selectedDimension);
  filteredProducts = _.uniqBy(filteredProducts, product => product.productName);
  const options = filteredProducts.map(product => ({ value: product.productName, label: product.productName }));

  return [{ value: "", label: i18n.t("billsOfLading.all") }, ...options];
};

export const getDimensions = (products, selectedCustomerPO, selectedProductName) => {
  let filteredProducts = filterCustomerPO(products, selectedCustomerPO);
  filteredProducts = filterProductName(filteredProducts, selectedProductName);
  filteredProducts = _.uniqBy(filteredProducts, product => formatDimension(product.dimension));

  const options = filteredProducts.map(product => {
    const formattedDimension = formatDimension(product.dimension);
    return { value: formattedDimension, label: formattedDimension };
  });

  return [{ value: "", label: i18n.t("billsOfLading.all") }, ...options];
};



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Filters/FilterHelpers.js